<mat-spinner diameter="20"></mat-spinner>
<span class="mat-body-2 loading-message flex">{{ message }}</span>
